import { EffectCallback, useEffect } from 'react';

export const useRunOnce = (effect: EffectCallback) => {
    // eslint-disable-next-line
    useEffect(effect, [])
}